export const API_BASE_URL = 'https://isp.skeletos.in/api/v1'
//export const API_BASE_URL = 'http://101.53.134.82:8028/api/v1'
export const DELETE_MESSAGE = 'Are you sure you want to delete the record?'
export const UPDATE_MESSAGE = 'Are you sure you want to update the record?'
export const CONFIRM_BUTTON_TEXT = 'Yes'
export const CANCLE_BUTTON_TEXT = 'No'
export const CONFIRM_BUTTON_COLOR = '#50CD89'
export const CANCLE_BUTTON_COLOR = '#F64E60'
export const ALREADY_EXISTS = 'Already user exists'
